<template>
  <div class="pano">
    <CustomNavBar :title="info?.title" />
    <div id="pano1" />

    <van-dialog v-model="jiankong" theme="round-button" title="实时监控">
      <VideoPlay v-if="sourcesSrc && jiankong" ref="video" :src="sourcesSrc" />
      <van-empty v-else image="network" description="暂无资源" />
    </van-dialog>

    <van-dialog
      v-if="data"
      v-model="qixiang"
      class="qixiang"
      theme="round-button"
    >
      <template #title>
        <div class="qixiang-header">
          <span>气象站</span>
          <van-icon
            :class="loading ? 'rotate' : ''"
            class="qixiang-header__icon"
            name="replay"
            :loading="loading"
            @click="onUpdateClick"
          />
        </div>
      </template>
      <van-empty
        v-if="data.deviceStatus === 'offline' || !data"
        image="network"
        description="设备离线"
      />
      <van-grid v-else class="qixiang-grid" :column-num="3">
        <van-grid-item
          v-for="(item1, index1) in data.dataItem"
          :key="index1"
          class="qixiang-grid-item"
        >
          <div :style="{ color: '#' + item1.alarmColor }">
            <p>{{ item1.registerName }}</p>
            <p>{{ item1.data }}</p>
            <p>{{ item1.unit }}</p>
          </div>
        </van-grid-item>
      </van-grid>
    </van-dialog>
  </div>
</template>

<script>
import CustomNavBar from "@/components/CustomNavBar";
import VideoPlay from "@/components/Video"
import { scenicInfo } from '@/api/scenic'
import { Toast } from 'vant';
import axios from "axios";
export default {
  name: "PanoView",
  components: {
    CustomNavBar,
    VideoPlay
  },
  filters: {
    num(value) {
      const num = Number(value).toFixed(1);
      return Number(num);
    },
  },
  data() {
    return {
      jiankong: false,
      qixiang: false,
      info: null,
      sourcesSrc: "",
      loading: false,
      krpano: null,
      show: true,
      data: [],
      token: null,
      overtime: null,
      tiem: null,
    };
  },
  created() {
    this.getToken();
    this.getInfo();
  },
  mounted() {
    clearInterval(this.tiem);
    this.$store.commit("set_istab", false);
  },
  destroyed() {
    this.krpano.call(`playsound(bgsnd, '' , 0)`);
    clearInterval(this.tiem);
  },

  methods: {
     onUpdateClick() {
      if (this.token) {
        this.getReal(this.token)
      }
    },

    getToken() {
      axios.get("/api/getToken?loginName=wfz&password=wfz").then((ret) => {
        const res = ret.data
        if (res.code === 1000) {
          this.token = res.data.token
          this.overtime = res.data.expiration;
        } else {
          Toast.fail('请求失败！');
        }
      });
    },

    getReal(token) {
      axios({
        url: `/api/data/getRealTimeDataByDeviceAddr?deviceAddrs=${this.info.qixiang}`,
        methods: "get",
        headers: { Authorization: token },
      }).then((res) => {
        const ret = res.data;
        if (ret.code === 1000) {
          const data = ret.data[0];
          const registers = [];
          data.dataItem.map((item) => {
            item.registerItem.map((item3) => {
              const item2 = Object.assign(item3, { nodeId: item.nodeId });
              registers.push(item2);
            });
          });
          this.data = {
            dataItem: registers,
            deviceStatus: data.deviceStatus
          };
          this.loading = false;
        }
      });
    },

    async getInfo() {
      const id = this.$route.query.id
      if (id) {
        this.info = await scenicInfo({ id: id })
        this.initKrpano();
      }
    },

    initKrpano() {
      const t = parseInt(new Date().getTime() / 1000) + ''
      embedpano({
        target: "pano1",
        xml: this.info.three_link + "/tour.xml?t=" + t,
        html5: "auto",
        mobilescale: 1.0,
        passQueryParameters: true,
        initvars: { HASH: t, mill: t },
        onready: (krpano_interface) => {
          if (this.info.qixiang !== '' || this.info.jiankong !== '[{"link": ""}]') {
            this.krpano_onready_callback(krpano_interface);
          }
        },
      });
    },

    krpano_onready_callback(krpano_interface) {
      this.krpano = krpano_interface.get("global");
      this.krpano.call(`playsound(bgsnd, '' , 0)`);
      this.krpano.set("events[dm].keep", true);
      this.krpano.set("events[dm].onnewscene", this.onnewscene);
      this.krpano.call(`playsound(bgsnd, ${this.info.music} , 0)`);
      this.tiem = setInterval(() => { this.getReal(this.token) }, 4000)
    },
    onnewscene() {
      const hotspots = this.krpano.get("hotspot").getArray();
      const that = this;
      const jiankong = JSON.parse(that.info.jiankong)
      hotspots.map((hotspot) => {
        jiankong.map((item, index1) => {
          const name = `hotspot_jiankong${index1}`
          if (hotspot.name === name) {
            hotspot.onclick = () => {
              that.sourcesSrc = item.link
              that.jiankong = true;
            };
          }
        })

        if (hotspot.name === "hotspot_qixiang") {
          hotspot.onclick = () => {
            that.qixiang = true;
          };
        }

        that.jiankong = false;
        that.qixiang = false;
      });
    },
  },
};
</script>

<style lang="scss">
.pano {
  width: 100%;
  height: 100%;
  position: relative;
}
#pano1 {
  width: 100%;
  height: calc(100% - 46px);
}

.qixiang {
  .qixiang-header {
    position: relative;
    .qixiang-header__icon {
      cursor: pointer;
      position: absolute;
      right: 5px;
      top: -5px;
    }

    .rotate {
      animation: van-rotate 0.8s linear infinite;
    }
  }
  .qixiang-grid {
    .qixiang-grid-item {
      & > div {
        user-select: none;
        pointer-events: none;

        p {
          text-align: center;
          margin: 4px 0;
          font-weight: bold;
          &:first-child {
            font-weight: bold;
          }
          &:first-child,
          &:last-child {
            font-size: 10px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
